export enum SuffixEnum {
  OD = 'OD',
  MD = 'MD',
}
